
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.action-block-wrapper{
  overflow:hidden;
  position:relative;
  display:block;
}

.image{
  position:absolute;
  right:0;
  left:0;
  top:0;
  bottom:0;
}

img{
  height:100%;
  width:100%;
  aspect-ratio:3/2;
  object-fit:cover;
  margin:0;
}

.content{
  height:100%;
  width:100%;
  z-index:1;
  background:var(--color-primary-lightest);
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  align-items:center;
  border-radius:var(--border-radius-rounded-default);
  gap:var(--spacing-6);
  position:relative;
}

@media (min-width: 768px){

.content{
    flex-direction:row;
    gap:var(--spacing-8)
}
  }

@media (min-width: 1024px){

.content{
    flex-direction:row;
    gap:var(--spacing-12)
}
  }

@media (min-width: 1380px){

.content{
    flex-direction:row;
    gap:var(--spacing-12);
    justify-content:space-around
}
  }

@media (min-width: 1920px){

.content{
    flex-direction:row;
    gap:var(--spacing-12);
    justify-content:space-around
}
  }

.text-container-wrapper{
  padding:var(--spacing-05);
  width:100%;
}

@media (min-width: 768px){

.text-container-wrapper{
    padding:var(--spacing-08)
}
  }

@media (min-width: 1024px){

.text-container-wrapper{
    padding:var(--spacing-16)
}
  }

.text-content-wrapper{
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items:flex-start;
  row-gap:var(--spacing-05);
}

@media (min-width: 1024px){

.text-content-wrapper{
    flex-direction:row;
    justify-content:space-between;
    align-items:flex-start;
    column-gap:var(--spacing-32)
}
  }

.cta-menu{
  width:100%;
}

@media (min-width: 1024px){

.cta-menu{
    min-width:50%
}
  }

.text-wrapper{
  width:100%;
  color:var(--color-neutral-dark);
  text-align:left;
  display:flex;
  flex-direction:column;
  row-gap:var(--spacing-02);
  justify-content:flex-start;
  font-size:var(--body-02-font-size);
}
`;